module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/tap-icon-e86d43ec2b39c8d95b798947cc1d1262.svg";